import request from "@/utils/request";

let activityUrl = process.env.VUE_APP_API_ACTIVITY_URL
// console.log(activityUrl)
export default {
  get(url){
    return request({
      url: url,
      method: 'get',
    } )
  },
  getVcode (data = {}) {
    return request("POST", '/storeAuction/User/getCode', data)
  },

  pcLogin (data = {}) {
    return request("POST", '/storeAuction/User/pcLogin', data);
  },

  config (data = {}) {
    return request("POST", '/storeAuction/Config/getConfig', data);
  },
  /**
   * 配置 （介绍）
   * @param data
   * @returns {*}
   */
  getConfig (data = {}) {
    return request({
      url: '/web/IntroduceConfig/getConfig',
      method: 'GET',
      params: data
    })
  },
  /**
   * 上传文件
   * @param data
   * @returns {*}
   */
  updateFile (data = {}) {
    return request({
      url: '/luckyBase/LuckyBase/uploadFile',
      method: 'POST',
      data: data
    })
  },
  /**
   * 验证码
   * @param data
   * @returns {*}
   */
  getCode (data = {}) {
    return request({
      url: '/museum/Order/getCode',
      method: 'POST',
      data: data
    })
  },
  /**
   * 验证码
   * @param data
   * @returns {*}
   */
  submitOrder (data = {}) {
    return request({
      url: '/museum/Order',
      method: 'POST',
      data: data
    })
  },
  /**
   * 预约查询
   * @param data
   * @returns {*}
   */
  getOrderList (data = {}) {
    return request({
      url: '/museum/Order/getOrderList',
      method: 'GET',
      params: data
    })
  },
  /**
   * 预约详情
   */
  getOrderDetail (data) {
    return request({
      url: `/museum/Order/get`,
      method: 'POST',
      params: data
    })
  },

  /*取消预约*/
  cancelOrder (data) {
    return request({
      url: `/museum/Order/cancel/`,
      method: 'POST',
      params: data
    })
  },
  getNews (data = {}) {
    return request({
      url: `/article/newList`,
      method: 'GET',
      params: data
    })
  },
  //报名
  getNewsDetails (data) {
    return request({
      url: `/article/${data}`,
      method: 'GET',
      // data: data
    })
  },
 activityApply (data) {
    return request({
      url: `/article/ArticApplication`,
      method: 'POST',
      data: data
    })
  },
  //签到
  signIn (data) {
    return request({
      url: `/article/ArticApplication/qd`,
      method: 'PUT',
      data: data
    })
  },

  //闭馆时间
  getCloseTime(){
    return request({
      url: `/museum/calendar/time`,
      method: 'GET',
    })
  },

  //获取用户信息
  getUserInfo(code) {
    return request({
      url: `/WxOpen/getToken?code=${code}`,
      method: 'GET',
    })
  },
}

